import React from "react";
import SmartSelect, {
  defaultOptionStyles,
  SmartSelectProps,
} from "components/SmartSelect";
import { Currency } from "types";
import { GroupBase } from "chakra-react-select";

type CurrencySelectOption = { label: string; value: Currency };

type CurrencySelectProps = Omit<
  SmartSelectProps<
    CurrencySelectOption,
    false,
    GroupBase<CurrencySelectOption>
  >,
  "value" | "options" | "onChange"
> & {
  currency: Currency;
  onChange: (currency: Currency) => void;
};

const currencyOptions: CurrencySelectOption[] = [
  {
    label: "ETH",
    value: Currency.Eth,
  },
  {
    label: "$HONEY",
    value: Currency.Honey,
  },
];

const CurrencySelect = ({
  currency,
  onChange,
  ...rest
}: CurrencySelectProps) => (
  <SmartSelect
    chakraStyles={{
      control: (provided) => ({
        ...provided,
        minH: "8",
        fontWeight: "semibold",
        fontSize: "sm",
      }),
      valueContainer: (provided) => ({
        ...provided,
        px: "2",
      }),
      option: (provided) => ({
        ...provided,
        ...defaultOptionStyles,
        px: "3",
        py: "1.5",
        fontSize: "sm",
      }),
      menuList: (provided) => ({
        ...provided,
        bg: "dark.900",
        borderRadius: "md",
        border: "none",
        py: "0",
        w: "auto",
        minW: "0",
      }),
    }}
    value={currencyOptions.find((option) => option.value === currency)}
    options={currencyOptions}
    onChange={(option) => onChange(option?.value!)}
    {...rest}
  />
);

export default CurrencySelect;
